var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 99",
    d: "M1.07908 4.24927C0.933884 2.36169 2.42635 0.75 4.31951 0.75H14.6805C16.5736 0.75 18.0661 2.36168 17.9209 4.24926L16.5363 22.2493C16.4061 23.9425 14.9941 25.25 13.2959 25.25H5.70412C4.00588 25.25 2.59395 23.9425 2.4637 22.2493L1.07908 4.24927Z",
    stroke: "#323232",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 9.5,
    cy: 8.5,
    r: 3.71,
    stroke: "#323232",
    strokeWidth: 1.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 100",
    d: "M5.77715 16.1861C5.66524 15.2908 6.36332 14.5 7.26556 14.5H11.7344C12.6367 14.5 13.3348 15.2908 13.2229 16.1861L12.7229 20.1861C12.629 20.9367 11.9909 21.5 11.2344 21.5H7.76556C7.00908 21.5 6.37098 20.9367 6.27715 20.1861L5.77715 16.1861Z",
    stroke: "#323232"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 101",
    x: 7,
    y: 16,
    width: 2,
    height: 2,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 102",
    x: 9,
    y: 19,
    width: 3,
    height: 1,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 104",
    x: 7,
    y: 19,
    width: 1,
    height: 1,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 103",
    x: 10,
    y: 16,
    width: 2,
    height: 1,
    fill: "#323232"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.a4623c21e595c22789e48f87503455aa.svg";
export { ForwardRef as ReactComponent };